import DamageReportEntity from '../commons/entity/DamageReportEntity';

export const labelsDictionary = DamageReportEntity.LABELS.reduce(
  (options, label) => ({
    ...options,
    [label.value]: label.label,
  }),
  {},
);
